// extracted by mini-css-extract-plugin
module.exports = {"claim":"claim_claim__1gD1_","frases":"claim_frases__l_6Lp","final":"claim_final__ouAW_"};